<template>
  <div>
    <!-- 操作 -->
    <div class="operate">
      <el-checkbox v-model="$parent.checked" @change="allChecked">{{
        $t("message.allChecked")
      }}
      </el-checkbox>
      <!-- 打印清单 -->
      <el-button size="mini" type="primary" @click="printList">{{ $t("message.printList") }}
      </el-button>
      <el-button size="mini" type="primary" @click="printNewList">新清单
      </el-button>
      <!-- 装箱 -->
      <el-button size="mini" type="primary" @click="encasement" v-if="isAuth(244)">{{ $t("message.encasement") }}
      </el-button>
      <!-- 单箱取消装箱 -->
      <el-button size="mini" type="primary" class="dark" @click="cancelEncasement" v-if="isAuth(245)">
        {{ $t("message.unpack") }}
      </el-button>
      <!-- 多箱一键取消 -->
      <el-button size="mini" type="primary" class="dark" @click="oneCancellatioBoxes" v-if="isAuth(245)">
        {{ $t("message.OneCancellatioBoxes") }}
      </el-button>
      <!-- 单商品取消 -->
      <el-button size="mini" type="primary" class="dark" @click="singleProductCancellation" v-if="isAuth(245)">
        {{ $t("message.SingleProductCancellation") }}
      </el-button>
      <!-- 同交易号商品 -->
      <el-button size="mini" type="success" class="secondary" @click="commoditiesWithTheSameTransactionNumber"
        v-if="userRole != 6">
        {{ $t("message.commoditiesWithTheSameTransactionNumber") }}
      </el-button>
      <!-- 添加箱子 -->
      <el-button size="mini" type="success" @click="addBox" v-if="isAuth(238)">{{ $t("message.addBox") }}
      </el-button>
      <!-- 删除箱子 -->
      <el-button size="mini" type="primary" class="dark" @click="deleteBox" v-if="isAuth(239)">
        {{ $t("message.delBox") }}
      </el-button>
      <!-- 箱规修改 -->
      <el-button size="mini" type="primary" class="secondary" @click="boxGaugeModification">
        {{ $t("message.boxGaugeModification") }}
      </el-button>

      <!-- 重量修改 -->
      <!-- <el-button size="mini" type="primary" class="secondary" @click="modificationOfWeigh">{{
        $t("message.modificationOfWeigh") }}
      </el-button> -->
      <!-- 装箱完了 -->
      <el-button size="mini" type="primary" class="secondary" @click="completeBox" v-if="isAuth(246)">
        {{ $t("message.finishPacking") }}
      </el-button>
      <!-- 装箱完了取消 -->
      <el-button size="mini" type="primary" class="dark" @click="unCompleteBox" v-if="isAuth(247)">
        {{ $t("message.finishPackingCancel") }}
      </el-button>
      <!-- 标记木箱 -->
      <el-button size="mini" type="primary" class="success" @click="markWooden(1)" v-if="isAuth(247) && userRole != 6">
        {{ $t("message.markedWoodenCase") }}
      </el-button>
      <!-- 取消标记木箱 -->
      <el-button size="mini" type="primary" class="dark" @click="markWooden(0)" v-if="isAuth(247) && userRole != 6">
        {{ $t("message.unmarkedCase") }}
      </el-button>
      <!-- 新增服务单 -->
      <el-button size="mini" type="success" @click="addServiceOrder" v-if="isAuth(768)">
        {{ $t("message.addServiceOrder") }}
      </el-button>
      <!-- 打印废弃单 -->
      <el-button size="mini" type="primary" @click="abandonedList" v-if="detail.discard_status">
        {{ $t("message.abandonedList") }}
      </el-button>
      <!-- 售中问题提出 -->
      <el-button size="mini" type="primary" @click="issueSubmissionDuringSale" v-if="isAuth(621)">
        {{ $t("message.issueSubmissionDuringSale") }}
      </el-button>
      <!-- 1868出货唛头 -->
      <el-button size="mini" type="primary" class="primary" @click="printShippingLabel1868"
        v-if="detail.user_id == 1868">
        1868出货唛头
      </el-button>
      <!-- 提交给业务 -->
      <el-button size="mini" type="primary" class="fr" @click="toWaitOffer" v-if="isAuth(241)">
        {{ $t("message.submissionToBusiness") }}
      </el-button>
      <!-- 退回待翻译 -->
      <el-button size="mini" type="primary" class="fr" @click="returnToTranslation" v-if="isAuth(240)">
        {{ $t("message.returnToTranslation") }}
      </el-button>
      <!-- 打印唛头 -->
      <el-button size="mini" type="primary" class="secondary fr" @click="shippingMarkForDistribution">
        {{ $t("message.shippingMarkForDistribution") }}
      </el-button>
      <!-- 打印装箱单 -->
      <el-button size="mini" type="success" class="fr" @click="printPackingList('')" v-if="userRole != 6">
        {{ $t("message.printPackingList") }}
      </el-button>
      <!-- 打印装箱单(无单价)-->
      <el-button size="mini" type="success" @click="printPackingList('NoPrice')" class="fr" v-if="userRole != 6">
        {{ $t("message.printPackingListNoPrice") }}
      </el-button>
    </div>
    <!-- 唛头打印 -->
    <div v-show="false">
      <div ref="boxshippingmark" v-if="prinData != false">
        <boxshippingmark :prinData="prinData" />
      </div>
    </div>
    <!-- 装箱打印 -->
    <div v-show="false">
      <div ref="Packinglist">
        <Packinglist :datas="item" v-for="(item, index) in PackingData" :key="index" />
      </div>
    </div>
    <!--列表  -->
    <div v-show="false">
      <printList ref="printList" />
    </div>
    <div v-show="false">
      <newPrintList ref="newPrintList" />
    </div>
    <!-- 1868标签打印 -->
    <div v-show="false">
      <div ref="shippingLabel1868" v-if="prinData1868 != false">
        <shippingLabel1868 :prinData="prinData1868" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import boxshippingmark from "@/components/Printedsheet/boxshippingmark";
import Packinglist from '@/components/Printedsheet/Packinglist'
import printList from './printList'
import newPrintList from './newPrintList'
import shippingLabel1868 from './shippingLabel1868'
export default {
  components: {
    boxshippingmark,
    Packinglist,
    printList,
    newPrintList,
    shippingLabel1868,
  },
  props: {
    selectedList: { type: Array },
    selectedList: { type: Array },
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      prinData: [],
      PackingData: [],
      userRole: localStorage.getItem('japanUserRoleStatus'), //工种
      prinData1868: [],
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
      boxList: (state) => state.porderDetail.boxList,
      list: (state) => state.porderDetail.list,
      detail: (state) => state.porderDetail.detail,
    }),
  },
  mounted() {
    this.$parent.$refs.getNotice.getNotice(this.detail.user_id, '配货注意事项')
    this.$parent.$refs.JPgetNotice.getNotice(this.detail.user_id, '检品注意事项')
    if (this.detail.fba_match_notice != false) {
      this.$parent.$refs.fbaMatchNotice.dialogVisible = true
    }
    // 该配送单为FBA配送单
    if (this.userRole == 5 && this.detail.is_FBA) {
      this.$parent.$refs.is_FBA.dialogVisible = true
    }
    this.variousPrompts()

  },
  methods: {
    // 各种提示
    variousPrompts() {
      let str = ''
      let num = 1
      if (!this.list.every(item => item.inSale == false)) {
        str += `<p>${num}:当前配送单有配送单相关售中问题产品未处理完成，装箱时请注意！！！</p>`
        num++
      }
      // if (!this.list.every(item => item.inSale == false)) {
      //   str += `<p>${num}:此配送单为FBA配送单，请确认是否操作。</p>`
      //   num++
      // }
      if (this.detail.porder_remark.client_remark_translate) {
        str += `<p style='color:red'>${num}:请注意！有业务进行备注翻译</p>
        <textarea disabled style="background-color: #fff;border: none; height: 150px; width: 100%;color:#333;font-size:14px;line-height:18px" >${this.detail.porder_remark.client_remark_translate}</textarea>
     `
      }
      if (str) {
        this.$alert(str, '提示', {
          confirmButtonText: '确定',
          center: true,
          dangerouslyUseHTMLString: true,
          callback: action => {
          }
        });
      }
    },
    //全选
    allChecked() {
      this.$emit("allChecked");
    },
    //添加箱子
    addBox() {
      this.$parent.$refs.addBox.dialogVisible = true;
    },
    //修改箱规
    boxGaugeModification() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.boxGaugeModification.dialogVisible = true;
    },
    //装箱预览
    encasement() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$parent.$refs.encasement.dialogVisible = true;
    },
    //修改箱子重量
    modificationOfWeigh() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.modificationOfWeigh.dialogVisible = true;
    },
    // 配送单-翻译提交
    submitTranslate() {
      let datas = {
        porder_sn: this.$route.query.porder_sn,
        client_remark_translate: this.$parent.detail.client_remark_translate,
        list: [],
      };
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].client_remark && this.list[i].y_remark == false) {
          this.$alert(this.list[i].order_sn + "客户商品备注未翻译", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return false;
        }
        datas.list.push({
          id: this.list[i].id,
          y_remark: this.list[i].y_remark,
        });
      }
      this.$api.porderApi.submitTranslate(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.porderDetail();
      });
    },
    //删除箱子
    deleteBox() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi.deleteBox({ ids: this.boxIds }).then((res) => {
            this.$message.success(res.msg);
            this.$store.dispatch("freightList", { porder_sn: this.porder_sn });
            this.$store.commit("setBoxIds", []);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 取消装箱
    cancelEncasement() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      if (this.boxIds.length > 1)
        return this.$message.error("只能单个箱子操作");
      this.$store.dispatch("boxDetail", { freight_id: this.boxIds[0] });
      this.$parent.$refs.cancelEncasement.dialogVisible = true;
    },
    //装箱完了
    completeBox() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$confirm(
        this.$t("message.areYouSureTheMarksArePackedProperly"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .completeBox({ freight_id_set: this.boxIds })
            .then((res) => {
              this.$message.success(res.msg);
              this.$store.dispatch("freightList", {
                porder_sn: this.porder_sn,
              });
              this.$store.commit("setBoxIds", []);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //装箱完了取消
    unCompleteBox() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$confirm(
        this.$t("message.areYouSureToReturnAfterPacking"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .unCompleteBox({ freight_id_set: this.boxIds })
            .then((res) => {
              this.$message.success(res.msg);
              this.$store.dispatch("freightList", {
                porder_sn: this.porder_sn,
              });
              this.$store.commit("setBoxIds", []);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //配送单-打包-退回-到待翻译
    returnToTranslation() {
      this.$confirm(
        this.$t("message.isBackToWaitTranslate"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .toWaitTranslate({ porder_sn: this.porder_sn })
            .then((res) => {
              // 有抽查的 是否跳过抽查
              if (res.code == 10006) {
                this.skipSpotCheck(res.msg, 'toWaitTranslate')
                return false
              }
              this.$message.success(res.msg);
              this.$store.dispatch("porderDetail", {
                porder_sn: this.porder_sn,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //-装箱完提交给业务
    toWaitOffer() {
      this.$confirm(
        this.$t("message.isSubmissionToBusiness"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .toWaitOffer({ porder_sn: this.porder_sn })
            .then((res) => {
              // 有抽查的 是否跳过抽查
              if (res.code == 10006) {
                this.skipSpotCheck(res.msg, 'toWaitOffer')
                return false
              }
              this.$message.success(res.msg);
              this.$store.dispatch("porderDetail", {
                porder_sn: this.porder_sn,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 跳过抽查
    skipSpotCheck(msg, api) {
      this.$confirm(
        msg,
        this.$t("message.hint"),
        {
          confirmButtonText: '继续操作', //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
          [api]({ porder_sn: this.porder_sn, reconfirm: 1 })
            .then((res) => {
              this.$message.success(res.msg);
              this.$store.dispatch("porderDetail", {
                porder_sn: this.porder_sn,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //配货打印唛头
    shippingMarkForDistribution() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.getMaitouData({ freightIds: this.boxIds, not_print: 1 }).then((res) => {
        res.data.forEach(item => {
          item.boxTotal = this.boxIds.length
        })
        this.prinData = res.data;
        this.$nextTick(() => {
          this.$print(this.$refs.boxshippingmark);
          this.prinData = []
        });
      });
    },
    // 1868出货唛头 
    printShippingLabel1868() {
      this.prinData1868 = []
      this.list.forEach(item => {
        if (item.checked) {

          // 取detail_y的第一个值
          let type = item.detail_y != false ? item.detail_y[0].value : ''
          let labelType = ''
          if (type.includes('／')) {
            labelType = type.split('／')[0]
          }
          // 没有检测类型时，取detail_y的第一个值
          if (labelType == '') {
            type = item.detail_y != false ? item.detail_y[1].value : ''
            if (type.includes('／')) {
              labelType = type.split('／')[0]
            }
          }
          this.prinData1868.push({
            sorting: item.sorting,
            detail_y: item.detail_y,
            order_sn: item.order_sn,
            order_detail_tag: item.porder_detail_tag != false ? item.porder_detail_tag[0] : '',
            confirm_num: item.confirm_num,
            num: item.num,
            type: labelType,
            g_name: item.g_name,
            p_name: item.p_name,
            y_name: item.y_name,
            purchase_no: item.order_purchase[0].purchase_no,
            order_purchase_express: item.order_purchase[0].order_purchase_express,
          })
        }
      })

      if (this.prinData1868.length == 0)
        return this.$message.error(
          this.$t("message.selectableOperational")
        );
      let flag = this.prinData1868.every(item => item.order_detail_tag != '')
      if (!flag) {
        return this.$message.error(
          '请选择有标的商品'
        );
      }
      this.$nextTick(() => {
        this.$print(this.$refs.shippingLabel1868);
        this.$nextTick(() => {
          this.prinData1868 = []
        }, 500)
      });
    },
    //打印装箱单
    printPackingList(type) {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.porderApi.boxDetailBatchPrint({ freight_id_set: this.boxIds }).then(res => {
        res.data.forEach(item => {
          item.total = 0
          item.porder_freight_detail.forEach(items => {
            item.total += items.num
            if (type) {
              items.order_detail.confirm_price = ''
            }
          })
        })
        this.PackingData = res.data;
        console.log(this.PackingData);
        this.$nextTick(() => {
          this.$print(this.$refs.Packinglist);
        });
      })
    },
    // 打印清单
    printList() {
      this.$nextTick(() => {
        this.$print(this.$refs.printList)
      })
    },
    // 打印新清单
    printNewList() {
      this.$nextTick(() => {
        this.$print(this.$refs.newPrintList);
      })
    },
    //同交易号
    commoditiesWithTheSameTransactionNumber() {
      let purchase_no = []
      let selectedList = []
      this.list.forEach(item => {
        if (item.checked) {
          item.order_purchase.forEach(items => {
            purchase_no.push(items.purchase_no)
          })
        }
      })
      this.list.forEach(item => {
        item.order_purchase.forEach(items => {
          purchase_no.forEach(purchase => {
            if (items.purchase_no == purchase) {
              item.checked = true
            }
          })
        })
        if (item.checked) {
          selectedList.push(item)
        }
      })
      this.$parent.selectedList = selectedList
      console.log(this.$parent.selectedList);
      this.$forceUpdate()
    },

    // 标记木箱
    markWooden(type) {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      let datas = {
        is_wooden: type,
        ids: this.boxIds
      }
      this.$api.porderApi.markWooden(datas).then((res) => {
        this.$message.success(res.msg);
        this.$store.dispatch("freightList", { porder_sn: this.porder_sn });
        this.$store.commit("setBoxIds", []);
      });
    },
    //打印废弃单
    abandonedList() {
      let boxIds = []
      this.boxList.forEach(item => {
        item.group.forEach(items => {
          items.list.forEach(box => {
            boxIds.push(box.id);
          })
        })
      })
      this.$api.porderApi.discardList({ porder_sn: this.porder_sn }).then(res => {
        let itemData = res.data.data[0]
        this.$api.getMaitouData({ freightIds: boxIds }).then((res) => {
          res.data.forEach((item) => {
            item.boxTotal = boxIds.length;
            item.reason = itemData.reason
            item.created_at = itemData.created_at
            item.abandon = itemData.abandon_type == 1 ? '客户要求废弃' : '联系不上超时废弃'
            // 二维码
            this.$QRCode.toDataURL(
              item.encrypt_freight_id,
              { errorCorrectionLevel: "L", margin: 2, width: 128 },
              (err, url) => {
                if (err) throw err;
                item.QRImgUrl = url;
              }
            );
          });
          let datas = {
            logistics: '废弃',
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.$store.commit('setPrintData', datas)
          this.$nextTick(() => {
            this.$print(this.$parent.$refs.abandoned);
            this.$store.commit('setPrintData', {})
          });
        });
      })
    },
    //新增服务单
    addServiceOrder() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        porder_sn: this.porder_sn,
        porder_detail_ids: []
      }
      this.selectedList.forEach(item => {
        if (item.option != null && item.option != false) {
          datas.porder_detail_ids.push(item.id)
        }
      })
      if (datas.porder_detail_ids.length == 0)
        return this.$message.error('无可新增服务单的商品，请选择有附加服务的商品后新增服务单');
      this.$parent.$refs.createServiceOrder.fba_name = this.detail.fba_name
      this.$parent.$refs.createServiceOrder.optionServicePreview(datas)
      this.$parent.$refs.createServiceOrder.dialogVisible = true
    },
    //多箱一键取消
    oneCancellatioBoxes() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.oneCancellatioBoxes.dialogVisible = true
    },
    //单商品取消 
    singleProductCancellation() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));

      if (this.selectedList.length > 1)
        return this.$message.error('只能选择一个商品');
      this.$parent.$refs.singleProductCancellation.dialogVisible = true
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let ids = []
      this.selectedList.forEach(item => {
        ids.push(item.order_detail_id)
      })
      this.$parent.$refs.inSalePreview.storePreview(ids)
    },
  },
};
</script>
<style lang='scss' scoped>
.operate {
  margin: 0 24px;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;

  .el-button {
    margin-left: 5px;
    padding: 7px 8px !important;
  }
}
</style>
